export default {
  loadingObjCount: {},
  isLoading: false,
  matrices: null,
  matrixDetails: null,
  calibrationHistory: null,
  filters: {
    name: null,
    teamIds: [],
    specCodes: [],
    userIds: [],
    userName: null,
    authorName: null,
    period: null,
    status: null,
    competence: [],
    efficiency: [],
    calibration: null,
    areaCode: null,
    fullData: null,
  },
  excludedFilters: {
    teamIds: [],
    specCodes: [],
    userIds: [],
    userName: null,
    competence: [],
    efficiency: [],
    period: null,
    fullData: null,
  },
  activeCard: null,
  pagination: {page: 1, offset: 0, limit: 10},
};
